import {Injectable} from '@angular/core';
import {AbstractModelService} from "../model/abstract-model.service";
import {ApiClientService} from "../api-client/api-client.service";
import {BillingLine} from '../../models/accounting/billing-line';

@Injectable({
  providedIn: 'root'
})
export class InvoiceLineService extends AbstractModelService<BillingLine> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/invoice-line', BillingLine);
  }
}
